import React from 'react';
import {
  required,
  Create,
  SimpleForm,
  TranslatableInputs,
  TextInput,
  ReferenceInput,
  SelectInput
} from 'react-admin';

const validateCategoryService = required('Selecione uma categoria de serviço!');
const validateName = [required('Digite o nome!')];

const SubCategoryServiceCreate = (props) => (
  <Create title="Nova Sub Categoria Serviço" {...props}>
    <SimpleForm redirect="/sub-category-service" >
      <ReferenceInput label="Categoria de Serviço" source="category_service_id" fullWidth={true} reference="category-service" validate={validateCategoryService}>
        <SelectInput optionText="name.pt_br" optionValue="id" />
      </ReferenceInput>
      <TranslatableInputs locales={['pt_br', 'en_us']} defaultLocale="pt_br">
        <TextInput source="name" label="Nome" fullWidth={true} validate={validateName} />
      </TranslatableInputs>
    </SimpleForm>
  </Create>
);

export default SubCategoryServiceCreate;
